"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilters = useFilters;
const React = require("react");
const index_1 = require("../index");
const SearchResultFilterService_1 = require("../../services/SearchResultFilterService");
function useFilters(selectedTab, dictionary, filterTypeKey = 'attributes') {
    const { buildFilterDetailsMap, buildClearRefinementsMap, buildFilters } = SearchResultFilterService_1.searchResultFilterService;
    const filterDetailsMap = buildFilterDetailsMap(selectedTab, filterTypeKey);
    const clearRefinementsMap = buildClearRefinementsMap(selectedTab);
    const filters = React.useMemo(() => {
        return buildFilters(filterDetailsMap, clearRefinementsMap, dictionary);
    }, [filterDetailsMap, clearRefinementsMap, dictionary]);
    return (0, index_1.useDependentFilters)(filters);
}
